import { RoleLiteModel } from 'api-hooks/role';
import { Expose, Type } from 'class-transformer';
import { CommonModel } from 'common/repositories/common.model';

// Model

export class UserModel extends CommonModel {
  name: string;
  email: string;

  @Expose({ name: 'deleted_at' })
  @Type(() => Date)
  deletedAt: Date;

  @Type(() => RoleLiteModel)
  roles: RoleLiteModel[];
}

export class TokenResultModel {
  @Expose({ name: 'token_type' })
  tokenType: string;

  @Expose({ name: 'expires_in' })
  expiresIn: number;

  @Expose({ name: 'access_token' })
  accessToken: string;

  @Expose({ name: 'refresh_token' })
  refreshToken: string;
}

export type LoginMutationInput = {
  username: string;
  password: string;
};

export type RefreshTokenMutationInput = {
  refreshToken: string;
};
